<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else class="col_12">
      <div class="d_flex_btwn">
        <h1 class="common_title">
          <span v-if="$route.params.id">Edit Inventory Brand</span> 
          <span v-else>Create a New Inventory Brand</span>
        </h1>
        <span>
          <router-link :to="{name: 'brands'}" class="btn btn_black">Back to List</router-link>
        </span>
      </div>
      <div class="card border_none">
        <div class="card_body pl_0 pr_0">
          <div class="row">
            <div class="col_6 pr_20">
              <div :class="['form_row_inline', {'has_error': errorFor('name')}]">
                <label class="required">Brand Name</label>
                <div class="form_input">
                  <input type="text" class="form_global" v-model="form.name">
                  <v-errors :errors="errorFor('name')"></v-errors>
                </div>
              </div>
            </div>
            <div class="col_6 pr_20">
                <div :class="['form_row_inline', { has_error: errorFor('status') }]">
                <label class="required">Status</label>
                <div class="form_radio">
                  <input
                    type="radio"
                    id="statusActive"
                    v-model="form.status"
                    value="1"
                  />
                  <label for="statusActive">Active</label>
                </div>
                <div class="form_radio">
                  <input
                    type="radio"
                    id="statusInactive"
                    v-model="form.status"
                    value="0"
                  />
                  <label for="statusInactive">Inactive</label>
                </div>
                <v-errors :errors="errorFor('status')"></v-errors>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col_6">
              <div class="form_row_inline">
                <label></label>
                <div class="form_input ">
                    <button class="btn btn_primary" :disabled="lyLoading" @click.prevent="update" v-if="$route.params.id">Update</button>
                    <button class="btn btn_primary" :disabled="lyLoading" @click.prevent="submit" v-else>Save</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import LoaderMaskComponent from "@/components/LoaderMaskComponent.vue";

    export default {
        name: 'inventory-brands-form',
        components: {LoaderMaskComponent},
        data(){
            return {
              lyLoading: false,
              form: {
                name: '',
                status: 1,
              },
            }
        },
        created() {
            if(this.$route.params.id){
              this.loadData(this.$route.params.id)
            }
        },
        methods: {
          loadData(typeId){
              this.lyLoading = true;
              this.axios.get('/inventory-brands/'+typeId)
              .then((response) => {
                let formData = response.data.data;
                this.form.name = formData.name
                this.form.status = formData.status
              })
              .catch(() => {
                  this.showFailMsg("Brand is not exists!");
              })
              .finally(() => {
                  this.lyLoading = false;
              })
          },
          submit() {
              this.allErrors = null;
              this.lyLoading = true;

              let formData = new FormData()

              Object.keys(this.form).forEach(key => {
                  formData.append(key, this.form[key] ? this.form[key] : '');
              })

              this.axios.post('/inventory-brands', formData)
              .then(() => {
                  this.resetForm();
                  this.showSuccessMsg("Inventory Brands Created Successfully!");
                  this.$router.push({ name: 'brands'})
              })
              .catch((err) => {
                  this.allErrors = err.response.data.errors
                  this.showFailMsg(err.response.data.message);
              })
              .finally(() => {
                  this.lyLoading = false;
              })

          },
          
          update(){
              this.allErrors = null;
              this.lyLoading = true;

              let formData = new FormData()

              formData.append('_method','PATCH')

             Object.keys(this.form).forEach(key => {
                const value = this.form[key];
                formData.append(key, value !== null && value !== undefined ? value : '');
              })

              this.axios.post('/inventory-brands/'+this.$route.params.id, formData)
              .then(() => {
                  this.showSuccessMsg("Inventory Brand Update Successfully!");
              })
              .catch((err) => {
                  this.allErrors = err.response.data.errors
              })
              .finally(() => {
                  this.lyLoading = false;
              })
          },
          resetForm(){
              this.form = {
                name: '',
                status: 1,
              }
          },
        }
    }
</script>
<style scoped>
  
</style>
